import parseNetCDF from 'netcdf-gcms';
import { getBufferContent, getExtension, getTargetProperty, referenceFind, } from "../common.js";
const chromatogram = {
    jpath: ['spectra', 'chromatogram'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: processChromatogram,
};
export default chromatogram;
function processChromatogram(filename, content) {
    const extension = getExtension(filename);
    const metaData = {};
    if (extension === 'cdf' || extension === 'netcdf') {
        const bufferContent = getBufferContent(content);
        const parsed = parseNetCDF(bufferContent, { meta: true });
        const firstSeries = parsed.series[0];
        if (parsed.series.length === 1 && firstSeries) {
            metaData.detector = firstSeries.name;
        }
    }
    return metaData;
}
//# sourceMappingURL=chromatogram.js.map